import { ActionType } from '../../../borrowers/common/BorrowerConstants';
import store, { borrowerActions } from '@apply/adminStore';
import { LoginApi } from '@apply/api';
import { applicationInsights } from '../../../ApplicationInsights';

export const executePrincipalAction = async (itemData: { actionId: number; principalId: number; entityId: number }, navigate) => {
    const { dispatch } = store;
    const loginApi = new LoginApi.LoginApi(applicationInsights);

    const onEditPrincipal = (principalId: number, entityId = 0) => {
        dispatch(
            borrowerActions.setEditPrincipalModal({
                editPrincipalModal: { isOpen: true, principalId, entityId },
            })
        );
        return true;
    };

    const onSendPasswordResetEmail = async (principalId: number) => {
        const response = await loginApi.forgotPasswordById(principalId);
        return response.statusCode === 200;
    };

    const onNavigatExperience = (principalId: number) => {
        if (navigate) {
            navigate(`/experiences/principals/${principalId}`);
        } else {
            window.location.href = `/experiences/principals/${principalId}`;
        }
        return true;
    };

    const onNotImplemented = () => {
        alert('Not Implemented!');
        return false;
    };

    switch (itemData.actionId) {
        case ActionType.EditPrincipal:
            return onEditPrincipal(itemData.principalId, itemData.entityId);
        case ActionType.SendPasswordResetEmail:
            return await onSendPasswordResetEmail(itemData.principalId);
        case ActionType.PrincipalExperience:
            return await onNavigatExperience(itemData.principalId);
        default:
            return onNotImplemented();
    }
};
